module.exports = __webpack_public_path__ + "static/media/carbonara-in-gray-bowl.51b5cf31.jpg";